import styles from './Form.module.scss';
import React, { useState, useEffect, useMemo } from 'react';
import { loginUser } from '../../../../store/actions/auth';
import { getTranslation } from '../../../../utils/translation';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

export default function Form() {
    const dispatch = useDispatch();

    const { loading, error } = useSelector(state => state.auth);

    const isLoading = useMemo(() => !error && loading, [error, loading]);

    const [values, setValues] = useState({ username: '', password: '' });
    const [passwordType, setPasswordType] = useState('password');
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        if (values.username !== '' && values.password !== '') {
            setFormValid(true);
        } else {
            setFormValid(false);
        }
    }, [values.username, values.password]);

    // When change any input value of the form
    const onChangeHandler = e => {
        const { name, value } = e.target;
        const trimmedValue = value.trim();

        setValues({ ...values, [name]: trimmedValue });
    };

    // When submit form function to run
    const onSubmitHandler = e => {
        e.preventDefault();
        if (values.username !== '' && values.password !== '') {
            dispatch(loginUser(values));
        }
    };

    return (
        <form onSubmit={onSubmitHandler}>
            <div className={styles.formGroup}>
                <label className={styles.label} htmlFor='username'>
                    {getTranslation('login.input.username')}
                </label>
                <div className={styles.inputGroup}>
                    <input
                        id='username'
                        name='username'
                        className={styles.input}
                        type='text'
                        value={values.username}
                        onChange={onChangeHandler}
                    />
                    <i className={classNames('icon-user', styles.icon, styles.inputIcon)} />
                    <button
                        type={'button'}
                        className={classNames('icon-keyboard', styles.icon, styles.keyboardIcon)}
                    />
                </div>
            </div>
            <div className={styles.formGroup}>
                <label className={styles.label} htmlFor='password'>
                    {getTranslation('login.input.password')}
                </label>
                <div className={styles.inputGroup}>
                    <input
                        id='password'
                        name='password'
                        className={styles.input}
                        type={passwordType}
                        value={values.password}
                        onChange={onChangeHandler}
                    />
                    <i className={classNames('icon-lock', styles.icon, styles.inputIcon)} />
                    <button
                        type='button'
                        className={classNames(styles.togglePswdBtn, {
                            [styles.inactive]: passwordType !== 'password',
                        })}
                        onClick={() =>
                            setPasswordType(passwordType === 'password' ? 'text' : 'password')
                        }
                    >
                        {passwordType === 'password'
                            ? getTranslation('login.input.show')
                            : getTranslation('login.input.hide')}
                    </button>
                    <button
                        type={'button'}
                        className={classNames('icon-keyboard', styles.icon, styles.keyboardIcon)}
                    />
                </div>
            </div>
            <button className={styles.submitBtn} type='submit' disabled={!formValid || isLoading}>
                {isLoading
                    ? getTranslation('login.actions.loading')
                    : getTranslation('login.actions.login')}
            </button>
        </form>
    );
}
